<template>
    <div>
        <v-card class="fill-height" elevation="0">
            <v-card color="#BE977E" elevation="0" height="150px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-account-search-outline</v-icon>
                    &nbsp;Student Data
                </v-card-title>
            </v-card>
            <v-card-text>
                This utility searches student data from the student database. <br /><br/>
                Search terms can be full or partial.&nbsp;
                <i>Example: a search for 'joh' would return results containing 'john', 'johnson', and 'johann'.</i> <br /><br />
                Clicking on icons under <b>Actions</b> column will allow you to view students data.
            </v-card-text>
            <v-card-text>
                <Search />
            </v-card-text>
        </v-card>
        <iframe name="hiddenframe" hidden></iframe>
    </div>
</template>
<script>
import Search from "../../../components/Admin/StudentData/Search.vue"
export default {
    components: {
        Search
    }
}
</script>
